import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import Zadara from "public/privateCloud/zadara-cloud.png";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={2}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "Zadara Cloud  - fully managed cloud services platform",
  title: "Industry true EC2-Alternate.",
  description: (
    <DescComp
      description={[
        "Zadara’s enterprise-grade cloud infrastructure, delivered through OneMind’s fully managed platform, is built for ultimate flexibility and performance. Designed to handle any workload, our solution provides on-demand compute, networking, and storage resources that adapt seamlessly across hybrid, multi-cloud, edge, and virtual environments.",
        "With Zadara’s consumption-based pricing model and zero data egress fees, businesses gain the agility to scale without worrying about hidden costs. Paired with OneMind’s expert-managed, cloud-native delivery, organizations get secure, high-performance infrastructure that just works—anywhere, anytime, and without operational overhead.",
      ]}
    />
  ),
  points: [
    "Pay-as-you-go pricing with no vendor lock-in ",
    "Fully managed cloud infrastructure ",
    "Guaranteed uptime and enterprise security",
  ],
  image: Zadara,
};
